// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorView__container___H104u","heading":"ErrorView__heading___D69NH","message":"ErrorView__message___2W0uI","logo":"ErrorView__logo___1IXIU"};